import classNames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

export const ParcoursTile = ({
  title,
  description,
  numberOnTheMap,
  onHover,
  active,
  index,
  eventPage
}) => {
  const hover = () => {
    onHover && onHover(numberOnTheMap - 1, index);
  }

  const className = classNames({
    'parcours-tile': true,
    'parcours-tile--active': active
  })

  return (
    <Link href={eventPage?.slug} className={className} onMouseOver={hover}>
      <div className="parcours-tile__number">
        <span>{ numberOnTheMap }</span>
      </div>
      <div className="parcours-tile__content">
        <div className="parcours-tile__content__title">{title}</div>
        <div className="parcours-tile__content__description">— {description}</div>
      </div>
      <div className="parcours-tile__arrow">
        
      </div>
    </Link>
  )
}